import { useParams } from 'react-router-dom';
import PatientActivity from '~/components/maud/patients/profile/tabs/patientActivity';

const ActivityPage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  return <PatientActivity patientId={patientId} />;
};

export default ActivityPage;
